import axios from 'axios'
import { assetUrl, getHeader } from '@/config'

const state = {
  assetTypeList: [],
  assetList: [{
    id: null,
    type_id: null,
    asset_no: null,
    asset_name: null,
    date_buy: null,
    date_reduce: null,
    date_process: null,
    asset_age: null,
    asset_age_remaining: null,
    asset_amount: '0',
    asset_amount_reduce: '0',
    asset_fix_amount: '0',
    outlet_code: null,
    status: null,
    serial_number: null,
    internal_number: null,
    condition: null,
    active: false,
    picture: null
  }]
}

const mutations = {
  SET_ASSET_TYPE_LIST (state, data) {
    state.assetTypeList = data
  },
  SET_ASSET_LIST (state, data) {
    state.assetList = data
  }
}

const actions = {
  getAssetList: ({ commit }) => {
    console.log('get asset list')
    axios.get(assetUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_ASSET_LIST', response.data.data)
      })
  },
  getAssetTypeList: ({ commit }) => {
    axios.get(assetUrl + '/type', { headers: getHeader() })
      .then(response => {
        commit('SET_ASSET_TYPE_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
